import { Attributes, Rules, ValueObject } from '@singularsystems/neo-core';
import ContactUsDetails from "./ContactUsDetails";

export default class CorrespondenceConfigValues extends ValueObject {

    constructor() {
        super();
        this.makeObservable();
    }

    @Rules.Required()
    public incomingPortalEmailAddress: string = "";

    @Rules.Required()
    public portalUrl: string = "";

    @Attributes.ChildObject(ContactUsDetails)
    public contactUsDetails: ContactUsDetails | null = null;

    // Client only properties / methods
}